import React from "react";
import { IoIosRadioButtonOn } from "react-icons/io";

const ApplicationStatus = () => {
  return (
    <div className="wrapper">
      <div className="card">
        <p>Hello <strong>Sandeep Kattamuri</strong></p>
        <p>
          Thank you very much for Applying to the position of <strong>Projects Executive</strong> at <strong>Synnat Pharma</strong>
        </p>
        <p>
          Your response to the Quiz/Assignment has been registered. The score has been recorded and shared with the company.
        </p>
        <p>The status of your application is as below.</p>
        <div className="table-responsive">
        <table className="table">
          <tbody>
            <tr >
              <td>1. Application</td>
              <td>[In progress]</td>
              <td><a href="#" className="clrlink">Complete Application</a></td>
              <td><a href="#" className="clrlink">View Submission</a></td>
              <td><a href="#" className="clrlink">Completed</a></td>
            </tr>
            <tr>
              <td>2. Behavioural Assessment</td>
              <td>[Not Started]</td>
              <td><a href="#" className="clrlink">Start Assessment</a></td>
              <td><a href="#" className="clrlink">Complete Assessment</a></td>
              <td><a href="#" className="clrlink">Completed</a></td>
            </tr>
            <tr>
              <td>3. Technical Quiz (Optional)</td>
              <td>[Not Started]</td>
              <td><a href="#" className="clrlink">Take Quiz</a></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
</div>
        <p style={{ marginTop: "1rem" }}>
          Use the above links to complete your Application.
        </p>
        <p>
          <span className="team-lywo">Team <a href="#">LYWO</a></span><br />
          on Behalf of <strong>Synnat Pharma</strong><br />
          Reply to: [Sender's Email Address]
        </p>
        <div style={{display:"flex"}}>
        <IoIosRadioButtonOn size={50} />
<IoIosRadioButtonOn style={{ fontSize: 50 }} />
</div>
      </div>
    </div>
  );
};


export default ApplicationStatus;
